import { SUBCLUSTERS } from '../subclusters.js';

const MARKETING_CLUSTER = {
    subclusters: [
        {
            key: SUBCLUSTERS.PROJECT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.SOCIAL_MEDIA_MARKETING,
        },
        {
            key: SUBCLUSTERS.CONTENT_CALENDAR,
        },
        {
            key: SUBCLUSTERS.STRATEGIC_PLANNING,
        },
        {
            key: SUBCLUSTERS.MARKETING_OPERATIONS,
        },
        {
            key: SUBCLUSTERS.CAMPAIGN_TRACKING,
        },
        {
            key: SUBCLUSTERS.EVENT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.EMAIL_MARKETING,
        },
        {
            key: SUBCLUSTERS.CREATIVE,
        },
        {
            key: SUBCLUSTERS.MEDIA_PRODUCTION,
        },
        {
            key: SUBCLUSTERS.TASKS,
        },
        {
            key: SUBCLUSTERS.MANAGING_ROUTINE_PROCESSES,
        },
        {
            key: SUBCLUSTERS.MANAGING_PROJECTS_PORTFOLIO,
        },
        {
            key: SUBCLUSTERS.REPORTING_TO_EXECUTIVES,
        },
        {
            key: SUBCLUSTERS.RESOURCE_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.CRM,
        },
    ],
    payments_view: {
        pricing: {
            sections: [
                {
                    section: 'COMMUNICATION_ESSENTIALS',
                },
                {
                    section: 'COLLABORATION_AND_SHARING_ESSENTIALS',
                },
                {
                    section: 'INSIGHTS_ESSENTIALS',
                },
                {
                    section: 'MARKETING_OTHER_ESSENTIALS',
                },
                {
                    section: 'MARKETING_ADVANCED_SECTION',
                },
                {
                    section: 'SECURITY_NEW',
                },
                {
                    section: 'ADVANCED_REPORTING',
                },
                {
                    section: 'SUPPORT_NEW',
                },
            ],
            tier_descriptions: {
                pro: 'pricingPage.tierDescriptions.marketing.pro',
                free: 'pricingPage.tierDescriptions.marketing.basic',
                basic: 'pricingPage.tierDescriptions.marketing.basic',
                standard: 'pricingPage.tierDescriptions.marketing.standard',
                enterprise: 'pricingPage.tierDescriptions.marketing.enterprise',
            },
            value_features: {
                pro: [
                    {
                        feature: 'CAMPAIGN_MANAGEMENT',
                    },
                    {
                        feature: 'HIGH_LEVEL_MARKETING_PLANNING',
                    },
                    {
                        feature: 'ADVANCED_PERMISSIONS',
                    },
                    {
                        feature: 'TIME_TRACKING',
                    },
                    {
                        feature: 'WORKFLOW_AND_APPROVAL_AUTOMATION',
                    },
                    {
                        feature: 'ADVANCED_REPORTS',
                    },
                    {
                        feature: 'PRIVATE_BOARDS',
                    },
                    {
                        feature: 'ADOBE_CREATIVE_CLOUD_PLUGIN',
                    },
                    {
                        feature: 'PRO_INTEGRATIONS',
                    },
                    {
                        feature: 'PRO_AUTOMATIONS',
                    },
                ],
                free: [
                    {
                        feature: 'MARKETING_TEMPLATES',
                    },
                    {
                        feature: 'MARKETING_REQUESTS_WITH_FORMS',
                    },
                    {
                        feature: 'UNLIMITED_TEMPLATES',
                    },
                    {
                        feature: 'UNLIMITED_VIEWERS',
                    },
                    {
                        feature: 'ASSETS_AND_FILE_MANAGEMENT',
                    },
                    {
                        feature: 'SINGLE_DASHBOARD',
                    },
                    {
                        feature: 'IMPORT_EXPORT_EXCEL',
                    },
                ],
                basic: [
                    {
                        feature: 'MARKETING_TEMPLATES',
                    },
                    {
                        feature: 'MARKETING_REQUESTS_WITH_FORMS',
                    },
                    {
                        feature: 'UNLIMITED_TEMPLATES',
                    },
                    {
                        feature: 'UNLIMITED_VIEWERS',
                    },
                    {
                        feature: 'ASSETS_AND_FILE_MANAGEMENT',
                    },
                    {
                        feature: 'SINGLE_DASHBOARD',
                    },
                    {
                        feature: 'IMPORT_EXPORT_EXCEL',
                    },
                ],
                standard: [
                    {
                        feature: 'TIMELINE',
                    },
                    {
                        feature: 'SOCIAL_CALENDAR',
                    },
                    {
                        feature: 'SHARE_INSIGHTS_WITH_GUESTS',
                    },
                    {
                        feature: 'EMAIL_INTEGRATION',
                    },
                    {
                        feature: 'MARKETING_ANALYTICS',
                    },
                    {
                        feature: 'STANDARD_INTEGRATIONS',
                    },
                    {
                        feature: 'STANDARD_AUTOMATIONS',
                    },
                    {
                        feature: 'DEADLINE_MANAGEMENT',
                    },
                ],
                enterprise: [
                    {
                        feature: 'ENTERPRISE_SCALE_AUTOMATIONS',
                    },
                    {
                        feature: 'MULTI_LEVEL_PERMISSIONS',
                    },
                    {
                        feature: 'TAILORED_ONBOARDING',
                    },
                    {
                        feature: 'ENTERPRISE_GRADE_SECURITY',
                    },
                    {
                        feature: 'PREMIUM_SUPPORT',
                    },
                    {
                        feature: 'ENTERPRISE_DASHBOARDS',
                    },
                    {
                        feature: 'WORK_PERFORMANCE_INSIGHTS',
                    },
                ],
            },
        },
    },
};

export { MARKETING_CLUSTER };
